import { requireAnyOrgPermission, requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../../ui/hooks';
import { DataTree } from '@juvare/common-data-table-ui/DataTree';
import { FiltersBar, useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import AddIcon from '@mui/icons-material/Add';
import { Box, FormControlLabel, Switch } from '@mui/material';
import React, { useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useOrganizationsTree } from '../../../hooks/useOrganizationsTree';
import { CustomOrganizationTreeItem } from './CustomOrganizationTreeItem';
import { OrganizationSlideout } from './OrganizationSlideout';
import { OrganizationsPageHeader } from './OrganizationsPageHeader';
export const OrganizationsTree = (props) => {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const navigationContext = useContext(NavigationContext);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const allowUserManageOrganizationMembers = requireAnySystemPermission(userState, 'manage-organizations', 'all-organizations-admin') ||
        requireAnyOrgPermission(userState, 'manage-members');
    const showPendingOnly = searchParams.get('showPendingOnly') === 'true';
    const staticFilters = {
        pending: showPendingOnly ? true : undefined,
    };
    const { dataTreeProps, filtersBarProps, totalPendingMemberships, orgMembershipCountMap, activeOrganizationId, reload } = useOrganizationsTree({
        staticFilters,
        includeVisible: true,
        includeByMembership: true,
        includeByOrgPermission: [],
    });
    const mainAction = {
        label: t('panels.organizations.addOrg'),
        icon: React.createElement(AddIcon, null),
        onClick: () => {
            navigationContext.navigate(() => {
                navigate({ pathname: 'new/' });
            });
        },
        'data-test': 'add-organization-button',
    };
    const filterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({
            sx: { maxWidth: { xs: undefined, sm: 340 } },
            label: t('common.search'),
            dataPath: 'search',
            dataTest: 'search-filter',
        });
        builder.quickFilterSelect({
            widget: 'form.select',
            sx: { maxWidth: { xs: undefined, sm: 280 } },
            label: t('panels.organizations.permission'),
            dataPath: 'permission',
            values: [
                { label: t('panels.organizations.manageFilter'), value: 'manage' },
                { label: t('panels.organizations.memberOfFilter'), value: 'member' },
            ],
            dataTest: 'permission-filter',
        });
    }, [t]);
    return (React.createElement(React.Fragment, null,
        !props.hideHeader && React.createElement(OrganizationsPageHeader, { pendingMemberships: totalPendingMemberships.toString() }),
        React.createElement(Box, { sx: { p: 4 } },
            React.createElement(DataTree, Object.assign({}, dataTreeProps, { border: true, mainAction: requireAnySystemPermission(userState, 'manage-organizations') ? mainAction : undefined, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), customHeaderElement: allowUserManageOrganizationMembers && (React.createElement(FormControlLabel, { sx: { mt: -2, mb: -2 }, label: t('panels.organizations.pendingOnly'), control: React.createElement(Switch, { checked: showPendingOnly, onChange: (_event, checked) => {
                            const newSearchParams = new URLSearchParams(searchParams);
                            if (checked) {
                                newSearchParams.set('showPendingOnly', 'true');
                            }
                            else {
                                newSearchParams.delete('showPendingOnly');
                            }
                            setSearchParams(newSearchParams, { replace: true });
                        } }) })), itemContentComponent: (props) => {
                    var _a;
                    return (React.createElement(CustomOrganizationTreeItem, Object.assign({}, props, { membershipCount: (_a = orgMembershipCountMap.get(props.item.id.split('_')[0])) !== null && _a !== void 0 ? _a : 0, onReload: reload })));
                } }))),
        React.createElement(OrganizationSlideout, { orgId: activeOrganizationId, onClose: () => dataTreeProps.onChangeActiveItemId(undefined) })));
};
